var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Grades } from '@hn-front/data-types';
import { format, parseISO } from 'date-fns';
import { Badge } from '../Badge';
import { TitleContainer, Description, ChallengeText, ChallengeTitle, ChallengeContainer, } from '../Common';
var Canceled = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, grades = _a.grades, author = _a.author, rest = __rest(_a, ["startDate", "endDate", "grades", "author"]);
    var start = format(parseISO(startDate), 'MMM dd');
    var end = format(parseISO(endDate), 'MMM dd');
    var gradesStr = grades.map(function (g) { return Grades[g].full; }).join(', ');
    return (_jsx(ChallengeContainer, __assign({ color: 'black80' }, rest, { children: _jsxs(Description, { children: [_jsxs(TitleContainer, { children: [_jsxs(ChallengeTitle, { children: [start, " - ", end] }, void 0), _jsx(Badge, { state: 'canceled' }, void 0)] }, void 0), _jsxs(ChallengeText, { children: ["4-week Math Challenge for ", gradesStr] }, void 0), _jsxs(ChallengeText, { children: ["Started by ", author] }, void 0)] }, void 0) }), void 0));
};
export { Canceled };
